module.exports = __webpack_public_path__ + "img/gxhyicon.bfc9c190.svg";